import { useContext } from "react";
import { FormContext } from "./useFormContext";
import { FormConfig } from "../types/form";

// Reads the loaded form config from FormContext. Earlier this hook used
// queryClient.getQueryData("form"), but the actual cache key is ["form", passcode] —
// the bare-string lookup always returned undefined, so consumers like the linked-record
// table received empty tags and could not resolve tagsfield labels.
export const useFormConfig = (): FormConfig | undefined => {
  return useContext(FormContext)?.config;
};
